/**
 * 인증 관련 상수
 * 모든 서브도메인에서 공유
 */

// 사용자 등급
export const USER_TIERS = {
  GUEST: 'guest',
  GENERAL: 'general',
  SUBSCRIBER: 'subscriber',
  FAMILY: 'family',
  ADMIN: 'admin'
};

// 사용자 상태
export const USER_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// 등급별 레이블 (한국어)
export const TIER_LABELS_KO = {
  [USER_TIERS.GUEST]: '게스트',
  [USER_TIERS.GENERAL]: '일반',
  [USER_TIERS.SUBSCRIBER]: '구독자',
  [USER_TIERS.FAMILY]: '패밀리',
  [USER_TIERS.ADMIN]: '관리자'
};

// 등급별 레이블 (영어)
export const TIER_LABELS_EN = {
  [USER_TIERS.GUEST]: 'Guest',
  [USER_TIERS.GENERAL]: 'General',
  [USER_TIERS.SUBSCRIBER]: 'Subscriber',
  [USER_TIERS.FAMILY]: 'Family',
  [USER_TIERS.ADMIN]: 'Admin'
};

// 등급 우선순위 (높을수록 상위)
export const TIER_PRIORITY = {
  [USER_TIERS.GUEST]: 0,
  [USER_TIERS.GENERAL]: 1,
  [USER_TIERS.SUBSCRIBER]: 2,
  [USER_TIERS.FAMILY]: 3,
  [USER_TIERS.ADMIN]: 4
};

/**
 * 등급 비교 함수
 * @param {string} tier1
 * @param {string} tier2
 * @returns {number} tier1이 높으면 양수, tier2가 높으면 음수
 */
export const compareTiers = (tier1, tier2) => {
  return (TIER_PRIORITY[tier1] || 0) - (TIER_PRIORITY[tier2] || 0);
};

/**
 * 특정 등급 이상인지 확인
 * @param {string} userTier
 * @param {string} requiredTier
 * @returns {boolean}
 */
export const hasMinimumTier = (userTier, requiredTier) => {
  return compareTiers(userTier, requiredTier) >= 0;
};
